var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTraded = function SvgTraded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m11.985 15.985 2.667 2.667 5.333-5.334M6.652 9.585a2.933 2.933 0 0 1 2.933-2.933h1.333c.775 0 1.518-.308 2.067-.854l.933-.933a2.933 2.933 0 0 1 4.16 0l.934.933c.549.547 1.293.854 2.066.854h1.334a2.933 2.933 0 0 1 2.933 2.933v1.333c0 .774.307 1.518.853 2.067l.934.933a2.934 2.934 0 0 1 0 4.16l-.934.934a2.93 2.93 0 0 0-.853 2.066v1.334a2.933 2.933 0 0 1-2.933 2.933h-1.334c-.774 0-1.517.307-2.066.853l-.934.934a2.935 2.935 0 0 1-4.16 0l-.933-.934a2.93 2.93 0 0 0-2.067-.853H9.585a2.933 2.933 0 0 1-2.933-2.933v-1.334c0-.774-.308-1.517-.854-2.066l-.933-.934a2.934 2.934 0 0 1 0-4.16l.933-.933c.546-.55.853-1.292.854-2.067z"
  })));
};
export default SvgTraded;